import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Segment,
  Input,
  Form,
  FormGroup,
  FormField,
  Checkbox,
  Dropdown,
  Button
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const ModDetailInvoiceUX = (props: any) => {
    return(
      <div
        id="ModDetailInvoiceUX-div-0">
        <Segment
          id="ModDetailInvoiceUX-Segment-1">
          <div
            id="ModDetailInvoiceUX-div-2"
            style={{height: "30px", width: "350px", backgroundColor: "#5dbcd2", alignContent: "center", marginBottom: "10px"}}>
            
            <div
              id="ModDetailInvoiceUX-div-3"
              style={{fontWeight: "bold", color: "white", marginLeft: "6px"}}>
              รายละเอียดค่ารักษาพยาบาล
            </div>
          </div>
          <hr
            id="ModDetailInvoiceUX-hr-4">
          </hr>
          <Segment
            id="ModDetailInvoiceUX-Segment-5">
            <div
              id="ModDetailInvoiceUX-div-6"
              style={{display: "flex", justifyContent: "flex-start", flexWrap: "wrap", rowGap: "24px"}}>
              
              <div
                id="ModDetailInvoiceUX-div-7"
                style={{fontWeight: "bold", marginRight: "50px"}}>
                HN :
                <Input
                  className="encounter-info encounter-info-center"
                  id="ModDetailInvoiceUX-Input-8"
                  readOnly={true}
                  style={{height: "24px", width: "100px", marginLeft: "10px"}}
                  value={props.selectedEncounter?.hn}>
                </Input>
              </div>
              <div
                id="ModDetailInvoiceUX-div-9"
                style={{fontWeight: "bold", marginRight: "50px"}}>
                ชื่อ - สกุล :
                <Input
                  className="encounter-info encounter-info-center"
                  id="ModDetailInvoiceUX-Input-10"
                  readOnly={true}
                  style={{height: "24px", marginLeft: "10px"}}
                  value={props.selectedEncounter?.patient_name}>
                </Input>
              </div>
              <div
                id="ModDetailInvoiceUX-div-11"
                style={{fontWeight: "bold", marginRight: "50px"}}>
                สิทธิรักษา (หลัก):
                <Input
                  className="encounter-info"
                  id="ModDetailInvoiceUX-Input-12"
                  readOnly={true}
                  style={{height: "24px", marginLeft: "10px"}}
                  value={props.selectedEncounter?.coverage}>
                </Input>
              </div>
              <div
                id="ModDetailInvoiceUX-div-13"
                style={{fontWeight: "bold", marginRight: "50px"}}>
                Payer :
                <Input
                  className="encounter-info"
                  id="ModDetailInvoiceUX-Input-14"
                  readOnly={true}
                  style={{height: "24px", marginLeft: "10px"}}
                  value={props.selectedEncounter?.payer_name}>
                </Input>
              </div>
              <div
                id="ModDetailInvoiceUX-div-15"
                style={{fontWeight: "bold", marginRight: "50px"}}>
                Encounter :
                <Input
                  className="encounter-info encounter-info-center"
                  id="ModDetailInvoiceUX-Input-16"
                  readOnly={true}
                  style={{height: "24px", width: "80px", marginLeft: "10px"}}
                  value={props.selectedEncounter?.id}>
                </Input>
              </div>
              <div
                id="ModDetailInvoiceUX-div-17"
                style={{fontWeight: "bold", marginRight: "50px"}}>
                ประเภท :
                <Input
                  className="encounter-info encounter-info-center"
                  id="ModDetailInvoiceUX-Input-18"
                  readOnly={true}
                  style={{height: "24px", width: "80px", marginLeft: "10px"}}
                  value={props.selectedEncounter?.type}>
                </Input>
              </div>
              <div
                id="ModDetailInvoiceUX-div-19"
                style={{fontWeight: "bold", marginRight: "50px"}}>
                วันเวลาที่รักษา :
                <Input
                  className="encounter-info encounter-info-center"
                  id="ModDetailInvoiceUX-Input-20"
                  readOnly={true}
                  style={{height: "24px", marginLeft: "10px"}}
                  value={props.selectedEncounter?.started}>
                </Input>
              </div>
              <div
                id="ModDetailInvoiceUX-div-21"
                style={{fontWeight: "bold"}}>
                แผนกที่รักษา :
                <Input
                  className="encounter-info encounter-info-center"
                  id="ModDetailInvoiceUX-Input-22"
                  readOnly={true}
                  style={{height: "24px", marginLeft: "10px"}}
                  value={props.selectedEncounter?.division_name}>
                </Input>
              </div>
              <div
                id="ModDetailInvoiceUX-div-23"
                style={{fontWeight: "bold", marginRight: "50px"}}>
                แพทย์เจ้าของไข้ :
                <Input
                  className="encounter-info encounter-info-center"
                  id="ModDetailInvoiceUX-Input-24"
                  readOnly={true}
                  style={{height: "24px", marginLeft: "10px"}}
                  value={props.selectedEncounter?.doctor_name}>
                </Input>
              </div>
            </div>
          </Segment>
          <div
            id="ModDetailInvoiceUX-div-25">
            
            <Form
              className="size small"
              id="ModDetailInvoiceUX-Form-26">
              <FormGroup
                id="ModDetailInvoiceUX-FormGroup-27"
                style={{display: "flex", alignItems: "center", flexWrap: "wrap"}}>
                <FormField
                  id="ModDetailInvoiceUX-FormField-28">
                  <Checkbox
                    checked={props.invoiceItemsFilter?.isBillModeType || false}
                    id="ModDetailInvoiceUX-Checkbox-34"
                    label="หมวดค่ารักษา"
                    name="isBillModeType"
                    onChange={props.onChangeFilter}
                    style={{fontWeight: "bold"}}>
                  </Checkbox>
                </FormField>
                <FormField
                  id="ModDetailInvoiceUX-FormField-29"
                  style={{marginRight: "24px"}}
                  width="3">
                  <Dropdown
                    disabled={!props.invoiceItemsFilter?.isBillModeType}
                    id="ModDetailInvoiceUX-Dropdown-35"
                    name="billModeType"
                    onChange={props.onChangeFilter}
                    options={props.billModeTypes}
                    selection={true}
                    style={{fontWeight: "bold"}}
                    value={props.invoiceItemsFilter?.billModeType}>
                  </Dropdown>
                </FormField>
                <FormField
                  id="ModDetailInvoiceUX-FormField-30">
                  <Checkbox
                    checked={props.invoiceItemsFilter?.isDate || false}
                    id="ModDetailInvoiceUX-Checkbox-36"
                    label="วันที่ค่าใช้จ่าย"
                    name="isDate"
                    onChange={props.onChangeFilter}
                    style={{fontWeight: "bold"}}>
                  </Checkbox>
                </FormField>
                <FormField
                  id="ModDetailInvoiceUX-FormField-31"
                  width={2}>
                  <div
                    id="ModDetailInvoiceUX-div-37"
                    style={{width: "100%"}}>
                    
                    <DateTextBox
                      disabled={!props.invoiceItemsFilter?.isDate}
                      id="ModDetailInvoiceUX-DateTextBox-38"
                      onChange={(value)=>props.onChangeFilter?.(null, {name: "startDate", value})}
                      style={{fontWeight: "bold"}}
                      value={props.invoiceItemsFilter?.startDate}>
                    </DateTextBox>
                  </div>
                </FormField>
                <FormField
                  id="ModDetailInvoiceUX-FormField-32"
                  style={{marginRight: "24px"}}
                  width={2}>
                  <div
                    id="ModDetailInvoiceUX-div-39"
                    style={{width: "100%"}}>
                    
                    <DateTextBox
                      disabled={!props.invoiceItemsFilter?.isDate}
                      id="ModDetailInvoiceUX-DateTextBox-40"
                      onChange={(value)=>props.onChangeFilter?.(null, {name: "endDate", value})}
                      style={{fontWeight: "bold"}}
                      value={props.invoiceItemsFilter?.endDate}>
                    </DateTextBox>
                  </div>
                </FormField>
                <FormField
                  id="ModDetailInvoiceUX-FormField-33">
                  <div
                    id="ModDetailInvoiceUX-div-41">
                    {props.buttonDetailSearch}
                  </div>
                </FormField>
              </FormGroup>
            </Form>
          </div>
          <div
            id="ModDetailInvoiceUX-div-42"
            style={{ display: props.orderBy == "Mode" ? "block" : "none", padding: "0 10px" }}>
            
            <Table
              className="--rt-tbody-overflow-y-hidden"
              data={props.invoiceItemsByMode}
              headers={"รหัสหมวด, ชื่อหมวดค่ารักษาพยาบาล, ราคา, ส่งเบิก, absorb, เบิกเอง, เบิกไม่ได้, ส่วนลด"}
              id="ModDetailInvoiceUX-Table-43"
              keys={"bill_mode__code, bill_mode__name, price__sum, send_claim__sum, absorb__sum, patient_claim__sum, non_claimable__sum, discount__sum"}
              minRows="0"
              showPagination={false}
              widths="120,515,115,115,115,115,115,115">
            </Table>
          </div>
          <div
            id="ModDetailInvoiceUX-div-44"
            style={{ display: props.orderBy == "Order" ? "block" : "none", padding: "0 10px" }}>
            
            <Table
              className="--rt-tbody-overflow-y-hidden"
              data={props.invoiceItemsByOrder}
              headers={"แผนก, ชื่อรายการคำสั่ง, ประเภท, วันที่และเวลาค่าใช้จ่าย, ราคา, ส่งเบิก, absorb, เบิกเอง, เบิกไม่ได้, ส่วนลด, ส่วนลดสิทธิ, รหัสส่วนลด, สถานะค่าใช้จ่าย"}
              id="ModDetailInvoiceUX-Table-45"
              keys={"division__name, display_name, encounter__type, created, price__sum, send_claim__sum, absorb__sum, patient_claim__sum, non_claimable__sum, discount__sum, pay__sum, discount_code, status__name"}
              minRows="0"
              showPagination={false}
              widths="120,180,65,160,80,80,80,80,80,80,80,120,120">
            </Table>
          </div>
          <div
            id="ModDetailInvoiceUX-div-46"
            style={{ display: props.orderBy == "Item" ? "block" : "none", padding: "0 10px" }}>
            
            <Table
              className="--rt-tbody-overflow-y-hidden"
              data={props.invoiceItemsByItem}
              headers={"รหัสหมวด, รหัสค่ารักษา, ชื่อรายการค่ารักษา, วันที่และเวลาค่าใช้จ่าย, จำนวน, ราคาต่อหน่วย, ราคา, ส่งเบิก, absorb, เบิกเอง, เบิกไม่ได้, ส่วนลด, ส่วนลดสิทธิ, รหัสส่วนลด"}
              id="ModDetailInvoiceUX-Table-47"
              keys={"mode_code, code, product, created, quantity, unitprice, price, send_claim, absorb, patient_claim, non_claimable, discount, drg_discount_amount, discount_code"}
              minRows="0"
              showPagination={false}
              widths="80,95,220,160,60,95,75,75,75,75,75,75,75,90">
            </Table>
          </div>
          <div
            id="ModDetailInvoiceUX-div-48"
            style={{marginTop: "24px"}}>
            
            <Button
              className={props.orderBy === "Mode" ? "active" : ""}
              color="teal"
              id="ModDetailInvoiceUX-Button-49"
              name="Mode"
              onClick={() => props.onChangeOrderBy("Mode")}
              size="mini"
              style={{marginRight: "8px"}}>
              By Mode
            </Button>
            <Button
              className={props.orderBy === "Order" ? "active" : ""}
              color="teal"
              id="ModDetailInvoiceUX-Button-50"
              name="Order"
              onClick={() => props.onChangeOrderBy("Order")}
              size="mini"
              style={{marginRight: "8px"}}>
              By Order
            </Button>
            <Button
              className={props.orderBy === "Item" ? "active" : ""}
              color="teal"
              id="ModDetailInvoiceUX-Button-51"
              name="Item"
              onClick={() => props.onChangeOrderBy("Item")}
              size="mini">
              By Item
            </Button>
          </div>
          <div
            id="ModDetailInvoiceUX-div-52"
            style={{display: "flex", flexWrap: "wrap", marginTop: "24px"}}>
            
            <div
              id="ModDetailInvoiceUX-div-53"
              style={{display: "flex", flexDirection: "column", alignItems: "flex-end", fontWeight: "bold", marginBottom: "16px", marginRight: "48px"}}>
              ราคารวม
              <Input
                id="ModDetailInvoiceUX-Input-54"
                readOnly={true}
                style={{height: "24px", width: "120px", marginTop: "4px"}}
                value={props.invoiceSummary?.price__sum}>
              </Input>
            </div>
            <div
              id="ModDetailInvoiceUX-div-55"
              style={{display: "flex", flexDirection: "column", alignItems: "flex-end", fontWeight: "bold", marginBottom: "16px", marginRight: "48px"}}>
              ส่งเบิก
              <Input
                id="ModDetailInvoiceUX-Input-56"
                readOnly={true}
                style={{height: "24px", width: "120px", marginTop: "4px"}}
                value={props.invoiceSummary?.send_claim__sum}>
              </Input>
            </div>
            <div
              id="ModDetailInvoiceUX-div-57"
              style={{display: "flex", flexDirection: "column", alignItems: "flex-end", fontWeight: "bold", marginBottom: "16px", marginRight: "48px"}}>
              absorb
              <Input
                id="ModDetailInvoiceUX-Input-58"
                readOnly={true}
                style={{height: "24px", width: "120px", marginTop: "4px"}}
                value={props.invoiceSummary?.absorb__sum}>
              </Input>
            </div>
            <div
              id="ModDetailInvoiceUX-div-59"
              style={{display: "flex", flexDirection: "column", alignItems: "flex-end", fontWeight: "bold", marginBottom: "16px", marginRight: "48px"}}>
              เบิกเอง
              <Input
                id="ModDetailInvoiceUX-Input-60"
                readOnly={true}
                style={{height: "24px", width: "120px", marginTop: "4px"}}
                value={props.invoiceSummary?.patient_claim__sum}>
              </Input>
            </div>
            <div
              id="ModDetailInvoiceUX-div-61"
              style={{display: "flex", flexDirection: "column", alignItems: "flex-end", fontWeight: "bold", marginBottom: "16px", marginRight: "48px"}}>
              เบิกไม่ได้
              <Input
                id="ModDetailInvoiceUX-Input-62"
                readOnly={true}
                style={{height: "24px", width: "120px", marginTop: "4px"}}
                value={props.invoiceSummary?.non_claimable__sum}>
              </Input>
            </div>
            <div
              id="ModDetailInvoiceUX-div-63"
              style={{display: "flex", flexDirection: "column", alignItems: "flex-end", fontWeight: "bold", marginBottom: "16px", marginRight: "48px"}}>
              ส่วนลด
              <Input
                id="ModDetailInvoiceUX-Input-64"
                readOnly={true}
                style={{height: "24px", width: "120px", marginTop: "4px"}}
                value={props.invoiceSummary?.discount__sum}>
              </Input>
            </div>
          </div>
          <div
            id="ModDetailInvoiceUX-div-65"
            style={{display: "flex", justifyContent: "right", marginTop: "16px"}}>
            
            <Button
              color="grey"
              id="ModDetailInvoiceUX-Button-66"
              onClick={props.onCloseButton}
              size="mini">
              ปิดหน้าต่าง
            </Button>
          </div>
        </Segment>
      </div>
    )
}


export default ModDetailInvoiceUX

export const screenPropsDefault = {}

/* Date Time : Mon Sep 08 2025 17:47:02 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-0"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Segment",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Segment-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{height: \"30px\", width: \"350px\", backgroundColor: \"#5dbcd2\", alignContent: \"center\", marginBottom: \"10px\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดค่ารักษาพยาบาล"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", color: \"white\", marginLeft: \"6px\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-hr-4"
        }
      },
      "seq": 4,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Segment",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Segment-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-start\", flexWrap: \"wrap\", rowGap: \"24px\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "HN :"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"50px\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Input",
      "parent": 7,
      "props": {
        "className": {
          "type": "value",
          "value": "encounter-info encounter-info-center"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Input-8"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{height: \"24px\", width: \"100px\", marginLeft: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedEncounter?.hn"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ - สกุล :"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"50px\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "Input",
      "parent": 9,
      "props": {
        "className": {
          "type": "value",
          "value": "encounter-info encounter-info-center"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Input-10"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height: \"24px\", marginLeft: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedEncounter?.patient_name"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "สิทธิรักษา (หลัก):"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"50px\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "Input",
      "parent": 11,
      "props": {
        "className": {
          "type": "value",
          "value": "encounter-info"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Input-12"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height: \"24px\", marginLeft: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedEncounter?.coverage"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "Payer :"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"50px\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Input",
      "parent": 13,
      "props": {
        "className": {
          "type": "value",
          "value": "encounter-info"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Input-14"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height: \"24px\", marginLeft: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedEncounter?.payer_name"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "Encounter :"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"50px\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "Input",
      "parent": 15,
      "props": {
        "className": {
          "type": "value",
          "value": "encounter-info encounter-info-center"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Input-16"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height: \"24px\", width: \"80px\", marginLeft: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedEncounter?.id"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภท :"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"50px\"}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "Input",
      "parent": 17,
      "props": {
        "className": {
          "type": "value",
          "value": "encounter-info encounter-info-center"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Input-18"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height: \"24px\", width: \"80px\", marginLeft: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedEncounter?.type"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "วันเวลาที่รักษา :"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"50px\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Input",
      "parent": 19,
      "props": {
        "className": {
          "type": "value",
          "value": "encounter-info encounter-info-center"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Input-20"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height: \"24px\", marginLeft: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedEncounter?.started"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนกที่รักษา :"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Input",
      "parent": 21,
      "props": {
        "className": {
          "type": "value",
          "value": "encounter-info encounter-info-center"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Input-22"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height: \"24px\", marginLeft: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedEncounter?.division_name"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์เจ้าของไข้ :"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"50px\"}"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Input",
      "parent": 23,
      "props": {
        "className": {
          "type": "value",
          "value": "encounter-info encounter-info-center"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Input-24"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height: \"24px\", marginLeft: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedEncounter?.doctor_name"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-25"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Form",
      "parent": 25,
      "props": {
        "className": {
          "type": "value",
          "value": "size small"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Form-26"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormGroup",
      "parent": 26,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-FormGroup-27"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", flexWrap: \"wrap\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-FormField-28"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-FormField-29"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"24px\"}"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-FormField-30"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-FormField-31"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-FormField-32"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"24px\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-FormField-33"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Checkbox",
      "parent": 28,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.invoiceItemsFilter?.isBillModeType || false"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Checkbox-34"
        },
        "label": {
          "type": "value",
          "value": "หมวดค่ารักษา"
        },
        "name": {
          "type": "value",
          "value": "isBillModeType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Dropdown",
      "parent": 29,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "!props.invoiceItemsFilter?.isBillModeType"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Dropdown-35"
        },
        "name": {
          "type": "value",
          "value": "billModeType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.billModeTypes"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceItemsFilter?.billModeType"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "Checkbox",
      "parent": 30,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.invoiceItemsFilter?.isDate || false"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Checkbox-36"
        },
        "label": {
          "type": "value",
          "value": "วันที่ค่าใช้จ่าย"
        },
        "name": {
          "type": "value",
          "value": "isDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-37"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 38,
      "name": "DateTextBox",
      "parent": 37,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.invoiceItemsFilter?.isDate"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-DateTextBox-38"
        },
        "onChange": {
          "type": "code",
          "value": "(value)=>props.onChangeFilter?.(null, {name: \"startDate\", value})"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceItemsFilter?.startDate"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 40,
      "name": "DateTextBox",
      "parent": 39,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.invoiceItemsFilter?.isDate"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-DateTextBox-40"
        },
        "onChange": {
          "type": "code",
          "value": "(value)=>props.onChangeFilter?.(null, {name: \"endDate\", value})"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceItemsFilter?.endDate"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonDetailSearch"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-41"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.orderBy == \"Mode\" ? \"block\" : \"none\", padding: \"0 10px\" }"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 43,
      "name": "Table",
      "parent": 42,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.invoiceItemsByMode"
        },
        "headers": {
          "type": "code",
          "value": "\"รหัสหมวด, ชื่อหมวดค่ารักษาพยาบาล, ราคา, ส่งเบิก, absorb, เบิกเอง, เบิกไม่ได้, ส่วนลด\""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Table-43"
        },
        "keys": {
          "type": "code",
          "value": "\"bill_mode__code, bill_mode__name, price__sum, send_claim__sum, absorb__sum, patient_claim__sum, non_claimable__sum, discount__sum\""
        },
        "minRows": {
          "type": "value",
          "value": "0"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "widths": {
          "type": "value",
          "value": "120,515,115,115,115,115,115,115"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-44"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.orderBy == \"Order\" ? \"block\" : \"none\", padding: \"0 10px\" }"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 45,
      "name": "Table",
      "parent": 44,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.invoiceItemsByOrder"
        },
        "headers": {
          "type": "code",
          "value": "\"แผนก, ชื่อรายการคำสั่ง, ประเภท, วันที่และเวลาค่าใช้จ่าย, ราคา, ส่งเบิก, absorb, เบิกเอง, เบิกไม่ได้, ส่วนลด, ส่วนลดสิทธิ, รหัสส่วนลด, สถานะค่าใช้จ่าย\""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Table-45"
        },
        "keys": {
          "type": "code",
          "value": "\"division__name, display_name, encounter__type, created, price__sum, send_claim__sum, absorb__sum, patient_claim__sum, non_claimable__sum, discount__sum, pay__sum, discount_code, status__name\""
        },
        "minRows": {
          "type": "value",
          "value": "0"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "widths": {
          "type": "value",
          "value": "120,180,65,160,80,80,80,80,80,80,80,120,120"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-46"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.orderBy == \"Item\" ? \"block\" : \"none\", padding: \"0 10px\" }"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 47,
      "name": "Table",
      "parent": 46,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.invoiceItemsByItem"
        },
        "headers": {
          "type": "code",
          "value": "\"รหัสหมวด, รหัสค่ารักษา, ชื่อรายการค่ารักษา, วันที่และเวลาค่าใช้จ่าย, จำนวน, ราคาต่อหน่วย, ราคา, ส่งเบิก, absorb, เบิกเอง, เบิกไม่ได้, ส่วนลด, ส่วนลดสิทธิ, รหัสส่วนลด\""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Table-47"
        },
        "keys": {
          "type": "code",
          "value": "\"mode_code, code, product, created, quantity, unitprice, price, send_claim, absorb, patient_claim, non_claimable, discount, drg_discount_amount, discount_code\""
        },
        "minRows": {
          "type": "value",
          "value": "0"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "widths": {
          "type": "value",
          "value": "80,95,220,160,60,95,75,75,75,75,75,75,75,90"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-48"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"24px\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "Button",
      "parent": 48,
      "props": {
        "children": {
          "type": "value",
          "value": "By Mode"
        },
        "className": {
          "type": "code",
          "value": "props.orderBy === \"Mode\" ? \"active\" : \"\""
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Button-49"
        },
        "name": {
          "type": "value",
          "value": "Mode"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onChangeOrderBy(\"Mode\")"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"8px\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "Button",
      "parent": 48,
      "props": {
        "children": {
          "type": "value",
          "value": "By Order"
        },
        "className": {
          "type": "code",
          "value": "props.orderBy === \"Order\" ? \"active\" : \"\""
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Button-50"
        },
        "name": {
          "type": "value",
          "value": "Order"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onChangeOrderBy(\"Order\")"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"8px\"}"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "Button",
      "parent": 48,
      "props": {
        "children": {
          "type": "value",
          "value": "By Item"
        },
        "className": {
          "type": "code",
          "value": "props.orderBy === \"Item\" ? \"active\" : \"\""
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Button-51"
        },
        "name": {
          "type": "value",
          "value": "Item"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onChangeOrderBy(\"Item\")"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-52"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", flexWrap: \"wrap\", marginTop: \"24px\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคารวม"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", flexDirection: \"column\", alignItems: \"flex-end\", fontWeight: \"bold\", marginBottom: \"16px\", marginRight: \"48px\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "Input",
      "parent": 53,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Input-54"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height: \"24px\", width: \"120px\", marginTop: \"4px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceSummary?.price__sum"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่งเบิก"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-55"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", flexDirection: \"column\", alignItems: \"flex-end\", fontWeight: \"bold\", marginBottom: \"16px\", marginRight: \"48px\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "Input",
      "parent": 55,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Input-56"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height: \"24px\", width: \"120px\", marginTop: \"4px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceSummary?.send_claim__sum"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "absorb"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", flexDirection: \"column\", alignItems: \"flex-end\", fontWeight: \"bold\", marginBottom: \"16px\", marginRight: \"48px\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Input",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Input-58"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height: \"24px\", width: \"120px\", marginTop: \"4px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceSummary?.absorb__sum"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกเอง"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-59"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", flexDirection: \"column\", alignItems: \"flex-end\", fontWeight: \"bold\", marginBottom: \"16px\", marginRight: \"48px\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "Input",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Input-60"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height: \"24px\", width: \"120px\", marginTop: \"4px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceSummary?.patient_claim__sum"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกไม่ได้"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", flexDirection: \"column\", alignItems: \"flex-end\", fontWeight: \"bold\", marginBottom: \"16px\", marginRight: \"48px\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Input",
      "parent": 61,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Input-62"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height: \"24px\", width: \"120px\", marginTop: \"4px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceSummary?.non_claimable__sum"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่วนลด"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-63"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", flexDirection: \"column\", alignItems: \"flex-end\", fontWeight: \"bold\", marginBottom: \"16px\", marginRight: \"48px\"}"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "Input",
      "parent": 63,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Input-64"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height: \"24px\", width: \"120px\", marginTop: \"4px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceSummary?.discount__sum"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-div-65"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"right\", marginTop: \"16px\"}"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "Button",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": "ปิดหน้าต่าง"
        },
        "color": {
          "type": "value",
          "value": "grey"
        },
        "id": {
          "type": "value",
          "value": "ModDetailInvoiceUX-Button-66"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCloseButton"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 66,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "name": "ModDetailInvoiceUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
